import { MapModel } from '@/types/models';
import { ZERO } from '@/constants/common';
import { AnnotationItemList } from '@/components/Map/Drawer/BioEntityDrawer/AnnotationItem/AnnotationItemList.component';
import './SubmapNotes.styles.css';

interface SubmapNotesProps {
  model: MapModel;
}

const getAuthorName = ({
  firstName,
  lastName,
  email,
  organisation,
}: MapModel['authors'][number]): string => {
  const name = [firstName, lastName].filter(Boolean).join(' ').trim();
  const details = [organisation, email].filter(Boolean).join(', ');
  if (name && details) {
    return `${name} (${details})`;
  }
  return name || details || 'Unknown author';
};

export const SubmapNotes = ({ model }: SubmapNotesProps): JSX.Element => {
  const { description, authors, references: annotations } = model;
  const hasDescription = description !== '';
  const hasAuthors = authors.length > ZERO;

  return (
    <div
      data-testid="submap-notes"
      className="mt-2 flex flex-col gap-3 rounded-lg bg-cultured px-4 py-3 text-sm"
    >
      <div>
        <h3 className="font-semibold">Description:</h3>
        {hasDescription ? (
          <div
            className="anchor-tag pt-1"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: description }}
          />
        ) : (
          <span className="font-normal">No description</span>
        )}
      </div>

      <div>
        <h3 className="font-semibold">
          Authors: {!hasAuthors && <span className="font-normal">No authors</span>}
        </h3>
        {hasAuthors && (
          <ul className="list-disc pl-5 pt-1">
            {authors.map(author => (
              <li key={author.id}>{getAuthorName(author)}</li>
            ))}
          </ul>
        )}
      </div>

      <AnnotationItemList annotations={annotations} />
    </div>
  );
};
